var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import ConversationTitleModal from "../modals/ConversationTitleModal";
import { addConversation, addParticipant } from "../../api";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import { getSdkConversationObject } from "../../conversations-objects";
var CreateConversationButton = function (props) {
    var t = useTranslation(["chat"]).t;
    var dispatch = useDispatch();
    var _a = bindActionCreators(actionCreators, dispatch), updateCurrentConversation = _a.updateCurrentConversation, addNotifications = _a.addNotifications, updateParticipants = _a.updateParticipants;
    var _b = __read(useState(false), 2), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var handleOpen = function () { return setIsModalOpen(true); };
    var _c = __read(useState([]), 2), selectedUsers = _c[0], setSelectedUsers = _c[1];
    var isTabletOrMobile = useMediaQuery({ query: "(max-width: 767px)" });
    var addParticipantToConvo = function (participant, convo) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, addParticipant(participant, "", true, convo, addNotifications)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.log(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx("button", { className: "create-convo-button btn btn-primary forum", onClick: function () {
                    return isTabletOrMobile
                        ? handleOpen()
                        : props.setIsCreatingConversation(!props.isCreatingConversation);
                }, children: t("new_convo") }), _jsx(ConversationTitleModal, { title: "", type: "new", isModalOpen: isModalOpen, setSelectedUsers: setSelectedUsers, onCancel: function () {
                    setIsModalOpen(false);
                }, onSave: function (title) { return __awaiter(void 0, void 0, void 0, function () {
                    var convo, sdkConvo, participants;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, addConversation("Conversation", updateParticipants, props.client, addNotifications)];
                            case 1:
                                convo = _a.sent();
                                sdkConvo = getSdkConversationObject(convo);
                                participants = __spreadArray([], __read(selectedUsers), false);
                                participants.map(function (participant) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, addParticipantToConvo(participant.value, sdkConvo)];
                                            case 1:
                                                participant = _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); });
                                setIsModalOpen(false);
                                updateCurrentConversation(convo.sid);
                                return [2 /*return*/];
                        }
                    });
                }); } })] }));
};
export default CreateConversationButton;
